import { render, staticRenderFns } from "./compliant.vue?vue&type=template&id=37095e59&"
import script from "./compliant.vue?vue&type=script&lang=js&"
export * from "./compliant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports